import { mapGetters } from 'vuex';
import composer from '@/composers';

/*
  This composition allows the view to do a
  dirty check against two values within the store.

  REQUIRED:
    - store.data
    - store.saved
*/

const listener = 'beforeunload';
const dirtyKey = 'isDirty';

export const component = (
  storeName: string,
  view: IView,
) => composer({
  mergeFunction: {
    created: {
      where: 'after',
      cb(this: any) {
        window.addEventListener(listener, this.checkDirtyWindow, true);
      },
    },
    beforeDestroy: {
      where: 'before',
      cb(this: any) {
        window.removeEventListener(listener, this.checkDirtyWindow, true);
      },
    },
  },
  beforeRouteLeave(to: any, from: any, next: any) {
    this[dirtyKey]
      ? this.$store.commit('dialog/CREATE', {
          title: 'Unsaved changes',
          content: 'You haven\'t saved your changes. Do you really want to leave?',
          compact: true,
          buttons: [
            {
              text: 'No, keep editing',
              click: (message: any) => {
                message.close();
                next(false);
              },
            },
            {
              text: 'Yes leave',
              click: (message: any) => {
                message.close();
                next();
              },
            },
          ],
        })
      : next();
  },
  methods: {
    checkDirtyWindow(e: any) {
      if (this[dirtyKey]) {
        e.preventDefault();
        e.returnValue = ''; // required for Chrome
      }
    },
  },
  computed: {
    ...mapGetters(storeName, [dirtyKey]),
  },
}, view);

export const store = (originalStore: any) => composer({
  getters: {
    [dirtyKey]: (state: any): boolean => (
      JSON.stringify(state.data) !== JSON.stringify(state.saved)
    ),
  },
}, originalStore);
